<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-head">Contents</p>
<p class="toc-chapter" id="copy-1"><span href="#/SadTaleoftheBr_copy" title="Link target outside of Sample">Copyright</span></p>
<p class="toc-chapter" id="pref-1"><a href="#/SadTaleoftheBr_pref1">Preface</a></p>
<p class="toc-chapter" id="chap-1"><a href="#/SadTaleoftheBr_chap1">I: The First Blasphemy</a></p>
<p class="toc-chapter" id="chap-2"><a href="#/SadTaleoftheBr_chap2">II: Bastards at Large</a></p>
<p class="toc-chapter" id="chap-3"><a href="#/SadTaleoftheBr_chap3">III: Night in the Mountains</a></p>
<p class="toc-chapter" id="chap-4"><a href="#/SadTaleoftheBr_chap4">IV: A Lamentable Loss</a></p>
<p class="toc-chapter" id="chap-5"><a href="#/SadTaleoftheBr_chap5">V: The Other Cheek</a></p>
<p class="toc-chapter" id="chap-6"><a href="#/SadTaleoftheBr_chap6">VI: The Teeth of a Donated Horse</a></p>
<p class="toc-chapter" id="chap-7"><a href="#/SadTaleoftheBr_chap7">VII: A Cautionary Yarn, Spun for Fathers and Daughters Alike</a></p>
<p class="toc-chapter" id="chap-8"><a href="#/SadTaleoftheBr_chap8">VIII: Enough Distractions</a></p>
<p class="toc-chapter" id="chap-9"><a href="#/SadTaleoftheBr_chap9">IX: Odd Men at Odds</a></p>
<p class="toc-chapter" id="chap-10"><a href="#/SadTaleoftheBr_chap10">X: Fresh Paths and Good Intentions</a></p>
<p class="toc-chapter" id="chap-11"><a href="#/SadTaleoftheBr_chap11">XI: A Humourous Adventure</a></p>
<p class="toc-chapter" id="chap-12"><a href="#/SadTaleoftheBr_chap12">XII: A Telling on the Mountain</a></p>
<p class="toc-chapter" id="chap-13"><a href="#/SadTaleoftheBr_chap13">XIII: The Start of a Tale Already Concluded</a></p>
<p class="toc-chapter" id="chap-14"><a href="#/SadTaleoftheBr_chap14">XIV: The Monotonous Road</a></p>
<p class="toc-chapter" id="chap-15"><a href="#/SadTaleoftheBr_chap15">XV: Prophets of the Schism</a></p>
<p class="toc-chapter" id="chap-16"><a href="#/SadTaleoftheBr_chap16">XVI: The Gaze of the Abyss</a></p>
<p class="toc-chapter" id="chap-17"><a href="#/SadTaleoftheBr_chap17">XVII: The Difficult Homecoming</a></p>
<p class="toc-chapter" id="chap-18"><a href="#/SadTaleoftheBr_chap18">XVIII: Beards of a Feather</a></p>
<p class="toc-chapter" id="chap-19"><a href="#/SadTaleoftheBr_chap19">XIX: Like the Beginning, the End of Winter Is Difficult to Gauge in the South</a></p>
<p class="toc-chapter" id="chap-20"><a href="#/SadTaleoftheBr_chap20">XX: Venetian Heartbreak</a></p>
<p class="toc-chapter" id="chap-21"><a href="#/SadTaleoftheBr_chap21">XXI: The Conflagration of Desires</a></p>
<p class="toc-chapter" id="chap-22"><a href="#/SadTaleoftheBr_chap22">XXII: Sins of the Father</a></p>
<p class="toc-chapter" id="chap-23"><a href="#/SadTaleoftheBr_chap23">XXIII: Ever Southward</a></p>
<p class="toc-chapter" id="chap-24"><a href="#/SadTaleoftheBr_chap24">XXIV: The Execution of the Grossbarts</a></p>
<p class="toc-chapter" id="chap-25"><a href="#/SadTaleoftheBr_chap25">XXV: The Monotonous Sea</a></p>
<p class="toc-chapter" id="chap-26"><a href="#/SadTaleoftheBr_chap26">XXVI: The Children’s Crusade</a></p>
<p class="toc-chapter" id="chap-27"><a href="#/SadTaleoftheBr_chap27">XXVII: Rhodes to Gyptland</a></p>
<p class="toc-chapter" id="chap-28"><a href="#/SadTaleoftheBr_chap28">XXVIII: The Rapturous Hunt</a></p>
<p class="toc-chapter" id="chap-29"><a href="#/SadTaleoftheBr_chap29">XXIX: Like the End, the Beginning of Winter Is Difficult to Gauge in the South</a></p>
<p class="toc-chapter" id="chap-30"><a href="#/SadTaleoftheBr_chap30">XXX: Their Just Reward</a></p>
<p class="toc-chapter" id="chap-31"><a href="#/SadTaleoftheBr_chap31">XXXI: The Final Heresy</a></p>
<p class="toc-chapter" id="bibl-1"><a href="#/SadTaleoftheBr_bibl1">Bibliography</a></p>
<p class="toc-chapter" id="ackn-1"><a href="#/SadTaleoftheBr_ackn1">Acknowledgments</a></p>
<p class="toc-chapter" id="appe-1"><a href="#/SadTaleoftheBr_appe1">Extras</a></p>
<p class="toc-chapter" id="auth-1"><a href="#/SadTaleoftheBr_auth1">Meet the Author</a></p>
<p class="toc-chapter" id="appe-2"><a href="#/SadTaleoftheBr_appe2">Interview</a></p>
<p class="toc-chapter" id="teas-1"><a href="#/SadTaleoftheBr_teas1">A Preview of <em>THE COMPANY</em></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// SadTaleoftheBr_toc.vue?dcb24e34